<footer class="footer-area">
    <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-xs-12">
            <div class="il-footerlogo">
              <figure class="mb-0">
                <img src="/assets/img/ilwhite.png" alt="" class="footerlogo">
                <!-- <img src="/assets/img/ilschools-footer.png" alt=""
                  class="footerlogo"> -->
              </figure>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-xs-12 quickflex">
            <div class="row align-items-center">
              <div class="col-lg-12 col-md-12 col-xs-12">
                <h4 class="quicklink">Quick Links</h4>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 col-md-12 col-12">
                <div class="mobsocial">
                  <a (click)="we_socialmedia('youtube')" href="https://www.youtube.com/c/InfinityLearnEdu" target="_blank">
                    <img src="/assets/img/youtube.png" alt="youtube" class="socialicons" />
                  </a>
                  <a (click)="we_socialmedia('instagram')" href=" https://www.instagram.com/infinitylearn_by_srichaitanya/"
                    target="_blank">
                    <img src="/assets/img/instagram.png" alt="instagram" class="socialicons" />
                  </a>
                  <a (click)="we_socialmedia('facebook')" href="https://www.facebook.com/InfinityLearn.SriChaitanya/"
                    target="_blank">
                    <img src="/assets/img/facebook.png" alt="facebook" class="socialicons" />
                  </a>
                  <a (click)="we_socialmedia('linkedin')"
                    href=" https://www.linkedin.com/company/infinity-learn-by-sri-chaitanya/" target="_blank">
                    <img src="/assets/img/linkedin.png" alt="linkedin" class="socialicons" />
                  </a>
                  <a (click)="we_socialmedia('twitter')" href="https://twitter.com/InfinityLearn_" target="_blank"><img
                      src="/assets/img/twitter.png" alt="twitter" class="socialicons" />
                  </a>
                </div>
              </div>
            </div>
      
      
          </div>
      
        </div>
        <div class="row address-flex">
          <div class="col-lg-6 col-md-6 col-xs-12">
            <div>
              <div class="footer-flex mb-15">
                <div class="mr-25">
                  <i class="fa fa-map-marker" aria-hidden="true"></i>
                </div>
                <div>
                  <p class="faddress">6th Floor, NCC Building, Durgamma Cheruvu <br> Road, Vittal Rao Nagar, HITEC City,
                    <br> Hyderabad, Telangana 500081.
                  </p>
                </div>
              </div>
              <div class="footer-flex mb-15">
                <div class="mr-25">
                  <i class="fa fa-envelope" aria-hidden="true"></i>
                </div>
                <div>
                  <a href="mailto:support@infinitylearn.com">
                    <p class="faddress">support@infinitylearn.com</p>
                  </a>
                </div>
              </div>
              <div class="footer-flex mb-15">
                <div class="mr-25">
                  <i class="fa fa-phone" aria-hidden="true"></i>
                </div>
                <div>
                  <p class="faddress"><a href="tel:18004194247" class="fsupport">1800 419 4247</a></p>
                </div>
              </div>
              <div class="footer-flex mb-15">
                <div class="mr-25">
                  <i class="fa fa-building" aria-hidden="true"></i>
                </div>
                <div>
                  <p class="faddress">Sri Chaitanya College
                    Admission Enquiries<br>040-66060606</p>
                </div>
              </div>
              <div class="footer-flex mb-15">
                <div class="mr-25">
                  <i class="fa fa-building" aria-hidden="true"></i>
                </div>
                <div>
                  <p class="faddress">Sri Chaitanya School Admission Enquiries<br>040-71045045 &
                    040-44600600 Ext 401,402 & 425</p>
                </div>
              </div>
            </div>
            <div class="social">
              <a (click)="we_socialmedia('youtube')" href="https://www.youtube.com/c/InfinityLearnEdu" target="_blank"><img
                  src="/assets/img/youtube.png" alt="youtube" class="socialicons"></a>
              <a (click)="we_socialmedia('instagram')" href="https://www.instagram.com/infinitylearn_by_srichaitanya/"
                target="_blank"><img src="/assets/img/instagram.png" alt="instagram" class="socialicons"></a>
              <a (click)="we_socialmedia('facebook')" href="https://www.facebook.com/InfinityLearn.SriChaitanya/"
                target="_blank"><img src="/assets/img/facebook.png" alt="facebook" class="socialicons"></a>
              <a (click)="we_socialmedia('linkedin')" href="https://www.linkedin.com/company/infinity-learn-by-sri-chaitanya/"
                target="_blank"><img src="/assets/img/linkedin.png" alt="linkedin" class="socialicons"></a>
              <a (click)="we_socialmedia('twitter')" href="https://twitter.com/InfinityLearn_" target="_blank"><img
                  src="/assets/img/twitter.png" alt="twitter" class="socialicons"></a>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-xs-12">
      
            <div class="row">
              <div class="col-md-4 col-4">
                <div>
                  <ul class="widgetarea">
                    <li><a href="{{homeRoute}}about">About Us</a></li>
                    <li><a href="{{homeRoute}}careers">Careers</a></li>
                    <li><a href="{{homeRoute}}leadership">Teams</a></li>
                    <li><a href="{{homeRoute}}life-at-infinitylearn">Life at Infinity Learn</a></li>
                    <li><a href="https://infinitylearn.com/surge/blog/">Blogs</a></li>
                    <li><a href="{{homeRoute}}press">Press</a></li>
                  </ul>
                </div>
              </div>
              <div class="col-md-5 col-5">
                <div>
                  <ul class="widgetarea">
                    <li><a href="https://infinitylearn.com/surge/" target="_blank">Free Material</a></li>
                    <li><a href="{{homeRoute}}teacher">Become a Teacher</a></li>
                    <li><a href="{{homeRoute}}ambassador">Become an Ambassador</a></li>
                    <li><a href="{{homeRoute}}jee/repeater">JEE Repeater</a></li>
                    <li><a href="{{homeRoute}}neet/repeater">NEET Repeater</a></li>
                    <li><a href="{{homeRoute}}results">Our Results</a></li>
                  </ul>
                </div>
              </div>
              <div class="col-md-3 col-3">
                <div>
                  <ul class="widgetarea">
                    <li><a href="https://srichaitanyaalumni.com">Alumni</a></li>
                    <li><a href="{{homeRoute}}terms">Terms & Conditions</a></li>
                    <li><a href="{{homeRoute}}privacy">Privacy Policy</a></li>
                    <li><a href="{{homeRoute}}refund-policy">Refund Policy</a></li>
                    <li><a href="grievances">Grievance Redressal</a></li>
                  </ul>
                </div>
              </div>
            </div>
      
            <div class="row">
              <div class="col-md-4 col-lg-4 col-4">
                <h6 class="fplayapps">InfinityLearn App</h6>
                <figure>
                  <a href="https://play.google.com/store/apps/details?id=com.infinitylearn.learn" target="_blank"><img
                      src="/assets/img/playstore-icon.png" alt="" class="ftrplaystore"></a>
                </figure>
              </div>
              
                <div class="col-md-4 col-lg-4 col-4" *ngIf="!newHeader">
                  <h6 class="fplayapps">Doubts App</h6>
                  <figure>
                    <a href="https://play.google.com/store/apps/details?id=com.infinitylearn.doubt" target="_blank"><img
                        src="/assets/img/playstore-icon.png" alt="" class="ftrplaystore"></a>
                  </figure>
                </div>

            </div>
          </div>
      
        </div>

        <ng-container *ngIf="newHeader">
          <div class="row stud_border">
            <div class="col-md-12 col-lg-12 col-12">
              <h4 class="study_mat_title">Youtube Channels <span class="strokeyellow"></span></h4>
            </div>
          </div>
            <div class="row channel_border">
              <div class="col-md-3 col-lg-3">
                <div class="footer-widget">
                  <ul>
                    <li><a href="https://www.youtube.com/@InfinityLearnEdu" target="_blank">
                        <strong>
                          Infinity Learn
                        </strong>
                        </a>
                    </li>
                  </ul>
                </div>
              </div>  
              <div class="col-md-3 col-lg-3">
                <div class="footer-widget">
                  <ul>
                    <li><a href="https://www.youtube.com/channel/UCiTjCIT_9EXV1Wp1cY0zaUA" target="_blank">
                        <strong>
                          Infinity Learn NEET
                        </strong>
                        </a>
                    </li>
                  </ul>
                </div>
              </div>  
              <div class="col-md-3 col-lg-3">
                <div class="footer-widget">
                  <ul>
                    <li><a href="https://www.youtube.com/channel/UCSZVTk6wAtmorpBjP_uEjpw" target="_blank">
                        <strong>
                          Infinity Learn JEE
                        </strong>
                        </a>
                    </li>
                  </ul>
                </div>
              </div>  
              <div class="col-md-3 col-lg-3">
                <div class="footer-widget">
                  <ul>
                    <li><a href="https://www.youtube.com/channel/UCXbYgdeEMH934DrhypI1MmA" target="_blank">
                        <strong>
                          Infinity Learn Class 9&10
                        </strong>
                        </a>
                    </li>
                  </ul>
                </div>
              </div>  
            </div>
          <div class="row stud_border">
            <div class="col-md-12 col-lg-12 col-12">
              <h4 class="study_mat_title">Telegram Channels<span class="strokeyellow"></span></h4>
            </div>
          </div>
          <div class="row channel_border">
            <div class="col-md-3 col-lg-3">
              <div class="footer-widget">
                <ul>
                  <li><a href="https://t.me/InfinityLearnEdu" target="_blank">
                      <strong>
                        Infinity Learn
                      </strong>
                      </a>
                  </li>
                </ul>
              </div>
            </div>  
            <div class="col-md-3 col-lg-3">
              <div class="footer-widget">
                <ul>
                  <li><a href="https://t.me/Infinity_Learn_NEET" target="_blank">
                      <strong>
                        Infinity Learn NEET
                      </strong>
                      </a>
                  </li>
                </ul>
              </div>
            </div>  
            <div class="col-md-3 col-lg-3">
              <div class="footer-widget">
                <ul>
                  <li><a href="https://t.me/InfinityLearnJEE" target="_blank">
                      <strong>
                        Infinity Learn JEE
                      </strong>
                      </a>
                  </li>
                </ul>
              </div>
            </div>  
            <div class="col-md-3 col-lg-3">
              <div class="footer-widget">
                <ul>
                  <li><a href="https://t.me/InfinityLearn9_10" target="_blank">
                      <strong>
                        Infinity Learn Class 9&10
                      </strong>
                      </a>
                  </li>
                </ul>
              </div>
            </div>  
          </div>
        </ng-container>

        <div class="row stud_border">
          <div class="col-md-12 col-lg-12 col-12">
            <h4 class="study_mat_title">Study Material <span class="strokeyellow"></span></h4>
          </div>
        </div>
        <div class="row top-border">
          <div class="col-md-4 col-lg-4">
            <div class="footer-widget">
              <ul>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/" target="_blank"><strong>NCERT
                      Solutions</strong></a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-12/" target="_blank">NCERT Solutions For
                    Class 12</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-12/maths/" target="_blank">NCERT Solutions
                    For Class 12 Maths</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-12/biology/" target="_blank">NCERT
                    Solutions For Class 12 Biology</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-12/physics/" target="_blank">NCERT
                    Solutions For Class 12 Physics</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-12/chemistry/" target="_blank">NCERT
                    Solutions For Class 12 Chemistry</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-11/" target="_blank">NCERT Solutions For
                    Class 11</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-11/maths/" target="_blank">NCERT Solutions
                    For Class 11 Maths</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-11/biology/" target="_blank">NCERT
                    Solutions For Class 11 Biology</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-11/physics/" target="_blank">NCERT
                    Solutions For Class 11 Physics</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-11/chemistry/" target="_blank">NCERT
                    Solutions For Class 11 Chemistry</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-10/" target="_blank">NCERT Solutions For
                    Class 10</a></li>
      
      
              </ul>
            </div>
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="footer-widget">
              <ul>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-10/maths/" target="_blank">NCERT Solutions
                    For Class 10 Maths</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-10/english/" target="_blank">NCERT
                    Solutions For Class 10 English</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-10/science/" target="_blank">NCERT
                    Solutions For Class 10 Science</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-10/social-science/" target="_blank">NCERT
                    Solutions For Class 10 Social Science</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-9/" target="_blank">NCERT Solutions For
                    Class 9</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-9/maths/" target="_blank">NCERT Solutions
                    For Class 9 Maths</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-9/english/" target="_blank">NCERT Solutions
                    For Class 9 English</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-9/science/" target="_blank">NCERT Solutions
                    For Class 9 Science</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-9/social-science/" target="_blank">NCERT
                    Solutions For Class 9 Social Science</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-8/" target="_blank">NCERT Solutions For
                    Class 8</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-8/maths/" target="_blank">NCERT Solutions
                    For Class 8 Maths</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-8/english/" target="_blank">NCERT Solutions
                    For Class 8 English</a></li>
      
              </ul>
            </div>
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="footer-widget">
              <ul>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-8/science/" target="_blank">NCERT Solutions
                    For Class 8 Science</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-8/social-science/" target="_blank">NCERT
                    Solutions For Class 8 Social Science</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-7/" target="_blank">NCERT Solutions For
                    Class 7</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-7/maths/" target="_blank">NCERT Solutions
                    For Class 7 Maths</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-7/english/" target="_blank">NCERT Solutions
                    For Class 7 English</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-7/science/" target="_blank">NCERT Solutions
                    For Class 7 Science</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-7/social-science/" target="_blank">NCERT
                    Solutions For Class 7 Social Science</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-6/" target="_blank">NCERT Solutions For
                    Class 6</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-6/maths/" target="_blank">NCERT Solutions
                    For Class 6 Maths</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-6/english/" target="_blank">NCERT Solutions
                    For Class 6 English</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-6/science/" target="_blank">NCERT Solutions
                    For Class 6 Science</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-solutions/class-6/social-science/" target="_blank">NCERT
                    Solutions For Class 6 Social Science</a></li>
              </ul>
            </div>
          </div>
        </div>
      
        <div class="row exem_border">
          <div class="col-md-4 col-lg-4">
            <div class="footer-widget">
              <ul>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-exemplar-solutions/" target="_blank"><strong>NCERT Exemplar
                      Solutions</strong></a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-exemplar-solutions/class-12/" target="_blank">NCERT
                    Exemplar Solutions For Class 12</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-exemplar-solutions/class-12/maths/" target="_blank">NCERT
                    Exemplar Solutions For Class 12 Maths</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-exemplar-solutions/class-12/biology/" target="_blank">NCERT
                    Exemplar Solutions For Class 12 Biology</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-exemplar-solutions/class-12/physics/" target="_blank">NCERT
                    Exemplar Solutions For Class 12 Physics</a></li>
                <li><a
                    href="https://infinitylearn.com/surge/study-materials/ncert-exemplar-solutions/class-12/chemistry/" target="_blank">NCERT
                    Exemplar Solutions For Class 12 Chemistry</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-exemplar-solutions/class-11/" target="_blank">NCERT
                    Exemplar Solutions For Class 11</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-exemplar-solutions/class-11/maths/" target="_blank">NCERT
                    Exemplar Solutions For Class 11 Maths</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-exemplar-solutions/class-11/biology/" target="_blank">NCERT
                    Exemplar Solutions For Class 11 Biology</a></li>
      
              </ul>
            </div>
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="footer-widget">
              <ul>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-exemplar-solutions/class-11/physics/" target="_blank">NCERT
                    Exemplar Solutions For Class 11 Physics</a></li>
                <li><a
                    href="https://infinitylearn.com/surge/study-materials/ncert-exemplar-solutions/class-11/chemistry/" target="_blank">NCERT
                    Exemplar Solutions For Class 11 Chemistry</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-exemplar-solutions/class-10/" target="_blank">NCERT
                    Exemplar Solutions For Class 10</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-exemplar-solutions/class-10/maths/" target="_blank">NCERT
                    Exemplar Solutions For Class 10 Maths</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-exemplar-solutions/class-10/science/" target="_blank">NCERT
                    Exemplar Solutions For Class 10 Science</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-exemplar-solutions/class-9/" target="_blank">NCERT Exemplar
                    Solutions For Class 9</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-exemplar-solutions/class-9/maths/" target="_blank">NCERT
                    Exemplar Solutions For Class 9 Maths</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-exemplar-solutions/class-9/science/" target="_blank">NCERT
                    Exemplar Solutions For Class 9 Science</a></li>
              </ul>
            </div>
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="footer-widget">
              <ul>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-exemplar-solutions/class-8/" target="_blank">NCERT Exemplar
                    Solutions For Class 8</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-exemplar-solutions/class-8/maths/" target="_blank">NCERT
                    Exemplar Solutions For Class 8 Maths</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-exemplar-solutions/class-8/science/" target="_blank">NCERT
                    Exemplar Solutions For Class 8 Science</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-exemplar-solutions/class-7/" target="_blank">NCERT Exemplar
                    Solutions For Class 7</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-exemplar-solutions/class-7/maths/" target="_blank">NCERT
                    Exemplar Solutions For Class 7 Maths</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-exemplar-solutions/class-7/science/" target="_blank">NCERT
                    Exemplar Solutions For Class 7 Science</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-exemplar-solutions/class-6/" target="_blank">NCERT Exemplar
                    Solutions For Class 6</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-exemplar-solutions/class-6/maths/" target="_blank">NCERT
                    Exemplar Solutions For Class 6 Maths</a></li>
                <li><a href="https://infinitylearn.com/surge/study-materials/ncert-exemplar-solutions/class-6/science/" target="_blank">NCERT
                    Exemplar Solutions For Class 6 Science</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-xs-12 text-center">
            <p class="copyright">Copyright © 2022. All Rights Reserved 2022</p>
          </div>
        </div>
    </div>
</footer>